import './card.css';
import { projects } from '../parallaxdata';
import { useScroll, useTransform, motion } from 'framer-motion';
import { useEffect, useRef } from 'react';
import Lenis from '@studio-freight/lenis';
import { useNavigate } from 'react-router-dom';

export default function Card({ scrollYProgress }) {
  const navigate = useNavigate();
  return (
    <main className="main">
      {projects.map((project, i) => {
        const targetScale = 1;
        const range = [i * 0.25, 1];
        return (
          <CardItem
            key={`p_${i}`}
            i={i}
            {...project}
            progress={scrollYProgress}
            range={range}
            targetScale={targetScale}
          />
        );
      })}
      {/* <div style={{ display: 'flex', justifyContent: 'center', marginTop: 40 }}>
        <button
          className="explore-btn"
          onClick={() => {
            navigate('/Career', { state: { scrollToCareersSection: true } });
          }}
        >
          Explore Careers
        </button>
      </div> */}
      {/* Add vlogo and vwordmask as final stacked cards */}
     
    </main>
  );
}

function CardItem({ i, title, description, src, link, color, progress, range, targetScale, logo }) {
  const container = useRef(null);
  const { scrollYProgress } = useScroll({
    target: container,
    offset: ['start end', 'start start']
  });
  const imageScale = useTransform(scrollYProgress, [0, 1], [2, 1]);
  const scale = useTransform(progress, range, [1, targetScale]);

  return (
    <div ref={container} className="cardContainer">
     
      <motion.div
        style={{
          backgroundImage: `url(/images/${src})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          scale,
          top: `calc(-2vh + ${i * 20}px)`
        }}
        className="card"
      >
        {/* Black overlay for readability */}
        <div className="card-overlay"></div>
        {/* Logo and title side by side */}
        <div className="card-header">
          {logo && logo.endsWith('.svg') ? (
            <img src={`/images/${logo}`} alt={title + ' logo'} className="card-logo-svg" />
          ) : logo ? (
            <img src={`/images/${logo}`} alt={title + ' logo'} style={{ maxWidth: 100, marginBottom: 16 }} />
          ) : null}
          <h2 className="card-title">{title}</h2>
        </div>
        <div className="body">
          <div className="description">
            <p>{description}</p>
            <span>
              <a className='explore-btn' href={link} target="_blank" rel="noopener noreferrer">Explore</a>
            </span>
          </div>
          {/* imageContainer can be removed if background is now the card itself... */}
        </div>
      </motion.div>
    
     
    </div>
  );
}
